// extracted by mini-css-extract-plugin
export default {"TimeContainer":"TimeContainer_TimeContainer__2-+mN"};